<script lang="ts">
	import { Link } from '$global/components/Link';

	interface Props {
		href: string;
		helper: import('svelte').Snippet | undefined;
	}

	let { href, helper }: Props = $props();
</script>

<span>
	{#if helper}
		{@render helper()}
	{:else}
		Personal Data is managed securely and in accordance with our <Link
			class="underline"
			target="_blank"
			rel="noopener noreferrer"
			{href}
		>
			Privacy Policy
		</Link>
	{/if}
</span>
